module.exports = __webpack_public_path__ + "img/callus_phone_icon.464c5c2a.png";